const { default: apiHelper } = require("./apiHelper")
const { API_ROUTES } = require("./constants")

exports.getSettings = () => {
    return apiHelper.get(API_ROUTES.GET_SETTINGS)
}

exports.createBanner = (data, onProgress) => {
    return apiHelper.upload(API_ROUTES.CREATE_BANNER, data, onProgress)
}

exports.editBanner = (data, onProgress) => {
    return data.has("backgroundImage")
        ? apiHelper.upload(API_ROUTES.EDIT_BANNER, data, onProgress)
        : apiHelper.post(API_ROUTES.EDIT_BANNER, data)
}

exports.updateSortIds = (data) => {
    return apiHelper.post(API_ROUTES.UPDATE_SORT_ID, data)
}

exports.deleteBanner = (data) => {
    return apiHelper.post(API_ROUTES.DELETE_BANNER, data)
}
